<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ action?: string }>()
const { t } = useI18n()
const locating = ref(false)
const locationError = ref(false)

function nearby() {
  if (!navigator.geolocation) {
    locationError.value = true
    return
  }
  locating.value = true
  locationError.value = false
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      const url = new URL(props.action || window.location.pathname, window.location.origin)
      url.searchParams.set('latitude', coords.latitude.toString())
      url.searchParams.set('longitude', coords.longitude.toString())
      window.location.assign(url.toString())
    },
    () => {
      locating.value = false
      locationError.value = true
    },
    { enableHighAccuracy: false, timeout: 8000 },
  )
}

function showMap(event: Event) {
  const button = event.currentTarget as HTMLElement
  const panel = button.closest('.map-consent')
  if (!panel) return
  panel.innerHTML = `<div class="text-center"><div class="text-4xl">⌖</div><p class="mt-3 font-bold">${t('player.search.map_ready')}</p><p class="mt-2 text-sm opacity-60">${t('player.search.map_private')}</p></div>`
}

onMounted(() => document.querySelectorAll('[data-map-consent]').forEach((button) => button.addEventListener('click', showMap)))
onBeforeUnmount(() => document.querySelectorAll('[data-map-consent]').forEach((button) => button.removeEventListener('click', showMap)))
</script>

<template>
  <div class="mt-4 flex flex-wrap items-center gap-3">
    <button class="btn btn-sm btn-ghost px-0 hover:bg-transparent" type="button" :disabled="locating" @click="nearby">
      <span aria-hidden="true">⌖</span>{{ locating ? t('player.search.locating') : t('player.search.nearby') }}
    </button>
    <span v-if="locationError" class="text-sm text-base-content/60">{{ t('player.search.location_denied') }}</span>
  </div>
</template>
